import { useState } from "react";

const useUpload = () => {
    const [uploadedFile, setUploadedFile] = useState(null);
    const [uploadedFileUrl, setUploadedFileUrl] = useState(null);
    const [error, setError] = useState(null);
    const [forceUpdate, setForceUpdate] = useState(false);

    const handleUpload = (event) => {
        const file = event.target.files[0];
        const maxSize = 1048576; // 1MB in bytes
        const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

        if (file) {
            if (!validImageTypes.includes(file.type)) {
                setError("Tipo de arquivo inválido. Apenas imagens JPEG, PNG e GIF são permitidas.");
                event.target.value = null; // Limpar o valor do input de arquivo
                setForceUpdate(prev => !prev); // Forçar atualização
                return;
            }

            if (file.size > maxSize) {
                setError("O arquivo é muito grande. O tamanho máximo permitido é 1MB.");
                event.target.value = null; // Limpar o valor do input de arquivo
                setForceUpdate(prev => !prev); // Forçar atualização
                return;
            }

            setUploadedFile(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setUploadedFileUrl(reader.result);
                setForceUpdate(prev => !prev); // Forçar atualização
            };
            reader.readAsDataURL(file);
            setError(null); // Clear any previous error
        }
    };

    return {
        uploadedFile,
        uploadedFileUrl,
        handleUpload,
        error,
        forceUpdate
    };
};

export default useUpload;